import React from 'react';
import styles from './styles.scss';

function Faq () {
  return (
    <div>
      <div className="row">
        <div className="col-md-9 col-center">
          <h1 className={`${styles.heading} bold-italics blue text-center mb50`}>
            Details:
          </h1>
        </div>
      </div>
      <div className={styles.faq}>
        <div className="row">
          <div className="col-sm-12">
            <h4 className="bold">
              $500 to start
            </h4>
            <p className="mb30">
              All you have to pay is $500 to get the ball rolling. This reserves
              your team of a dedicated product manager and two designers. From
              there, you’ll pay weekly installments as work is completed and
              approved by you. And, if it doesn't work out, we guarantee a 100%
              refund.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <h4 className="bold">
              Validate before you build
            </h4>
            <p className="mb30">
              Common knowledge says to just hack something together and see how
              it goes. But, we’ve found some problems with this approach,
              especially if you can’t code yourself. Building before you
              validate your idea can cost more than you can afford and cripple
              your startup. We try to minimize early mistakes and hyper-focus
              your idea. In the end, $15k will pay for itself in future savings.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <h4 className="bold">
              5 startups only
            </h4>
            <p className="mb30">
              Keeping things small allows us to focus and add intentional value.
              You’re not 1 of 1,000. You’re 1 of 5 other founders that will go
              through the project. That means the risk of failure is
              dramatically reduced and you are ensured top quality in the end.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <h4 className="bold">
              Applying
            </h4>
            <p>
              We ask each interested founder to submit an application before
              beginning a project. Not only does this enable us to keep it
              small, but it ensures that we can really add value to your
              startup. If it’s out of our realm, we won’t take the project.
            </p>
            <p className="mb30">
              After you apply, we’ll review your application internally and
              schedule a phone call to ensure its a good fit. If both checkout,
              we’ll invite you to take part in the project, sign contracts, and
              begin our 30-day sprint!
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <h4 className="bold">
              Deliverables
            </h4>
            <p className="mb30">
              All of your deliverables will be accessible via a shared Dropbox
              folder. For all the graphics and visuals, you’ll have access to
              the fully-editable files, fonts, photos, and post-able PNGs. For
              your written documents, you’ll have those in Word and PDF formats.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <h4 className="bold">
              $15k is a real investment
            </h4>
            <p className="mb30">
              Although product consultants can charge up to $250/hr and firms
              can charge $250k for a full product, we realize that $15k is still
              a considerable investment into your idea. We’re lean builders
              ourselves. So to ensure a safe and sound investment, we’ve
              phone-call vetted each product manager, worked with all of our
              core designers, and built a team with over 100 years of combined
              startup experience to ensure successful results.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq;



// WEBPACK FOOTER //
// ./src/components/StartupFaq/index.js